module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.collection) ? _c('section', {
    staticClass: "collection--items",
    attrs: {
      "id": "items"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h5"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.options.isPurchase || _vm.readMore == true) ? [_c('div', {
    staticClass: "textbody",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), (_vm.readMore) ? _c('div', {
    staticClass: "spacer"
  }) : _vm._e()] : (_vm.text) ? [_c('button', {
    on: {
      "click": function($event) {
        _vm.readMore = !_vm.readMore
      }
    }
  }, [_c('span', {
    staticClass: "h6 readmore"
  }, [_vm._v("Read Description")])])] : _vm._e()], 2), _vm._v(" "), _c('ul', _vm._l((_vm.products), function(product) {
    return _c('li', [_c('sku-item', {
      attrs: {
        "product": product,
        "viewName": _vm.itemViewName,
        "isPurchase": _vm.options.isPurchase,
        "collectionSlug": _vm.slug
      }
    })], 1)
  }), 0), _vm._v(" "), _c('footer', [(_vm.cart !== null && this.cart.lineItemCount > 0) ? [_c('a', {
    staticClass: "enquire-btn century-mono",
    attrs: {
      "id": "placeOrderBtn",
      "href": this.cart.checkoutUrl
    }
  }, [_c('span', {
    staticClass: "h5"
  }, [_vm._v("CHECKOUT")])])] : [(_vm.options.customOrders) ? [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.products.length > 0),
      expression: "products.length > 0"
    }],
    staticClass: "enquire-btn century-mono",
    attrs: {
      "id": "enquireBtn",
      "href": 'mailto:' + _vm.email,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "h5 label"
  }, [_vm._v("CUSTOM ORDERS")]), _vm._v(" "), _vm._m(0)])] : _vm._e()]], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "products": _vm.products,
      "collectionTitle": _vm.shortTitle
    }
  })], 1), _vm._v(" "), (_vm.slug === 'bespoke-service' && _vm.collections.length && _vm.collections[0].data['collection.items--enquire-email']) ? _c('div', [_c('a', {
    staticClass: "enquire-btn",
    attrs: {
      "href": 'mailto:' + _vm.collections[0].data['collection.items--enquire-email'].value[0].text
    }
  }, [_vm._v("Enquire")]), _vm._v(" "), _c('br')]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h8"
  }, [_vm._v("For purchasing options"), _c('br'), _vm._v(" and bespoke enquiries please"), _c('br'), _vm._v(" contact us here.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4a40b40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__SKUs.vue
// module id = 397
// module chunks = 1